import { ENTITY_CONFIGS } from '@/components/customizing/EntityConfigs';
import type { EntityConfig } from '@/types/customizing';

/** Material entity config for create/edit dialogs; omits confidential when user lacks that privilege. */
export function getMaterialEntityConfig(options: { showConfidential: boolean }): EntityConfig {
  const base = ENTITY_CONFIGS.materials;
  if (options.showConfidential) {
    return base;
  }
  return {
    ...base,
    fields: base.fields.filter((f) => f.name !== 'isConfidential'),
  };
}

/** KO MaterialPopup parity: name + label only for inline create dialogs. */
export function getInlineMaterialEntityConfig(): EntityConfig {
  const base = ENTITY_CONFIGS.materials;
  return {
    ...base,
    fields: base.fields.filter((f) => f.name === 'name' || f.name === 'label'),
  };
}

/** Empty record for inline material create dialogs. */
export function emptyInlineMaterialRecord(forSubstrate: boolean): Record<string, unknown> {
  return {
    id: '',
    name: '',
    label: '',
    isConfidential: false,
    isSubstrate: forSubstrate,
  };
}
